app-pageselector {
    position: absolute;
    z-index: 1;
    transform: translate(-50%, -50%);
    left: 50%;

    .app-pageselector {
        background: #fff;
        padding: 0;
        width: 663px;
        border-radius: 48px;
        box-shadow: 0px 12px 22px #2D2F3B40;

        &__inner {
            display: flex;
            align-items: center;
            justify-content: center;
            @include paddings(24,24,24,48);
            height: 96px;
        }

        &__title {
            font-family: $font-family-primary-bold;
            color: $gray-dark;
            @include text-size(20);
            @include line-height(30);
        }

        &__selector {
            position: relative;
            max-width: 320px;
            @include margins(0,27,0,16);
            flex-grow: 1;
            z-index: 1;
        }

        &__menu {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #28313B;
            border-bottom: 1px solid $gray-dark;
            cursor: pointer;
            user-select: none;

            span {
                @include text-size(16);
                @include line-height(24);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            svg {
                @include margin-direction(left, 10);
                @include svg-format(12px, 16px, $primary);
                transition: transform 350ms;
            }
        }

        &__items {
            display: none;
            position: absolute;
            background: #fff;
            width: 100%;
            border-top: none;
            max-height: 300px;
            overflow-y: auto;
            box-shadow: 0px 3px 6px #00000029;
        }

        &__item {
            color: $gray-dark;
            display: block;
            @include paddings(12,12,12,12);
            cursor: pointer;
            user-select: none;
            text-decoration: none;
            transition: all 0.3s ease-out;

            &:hover,
            &:focus {
                background: $primary;
            }
        }

        &__selector.--open {
            .app-pageselector__menu {
                svg {
                    transform: rotate(180deg);
                }
            }

            .app-pageselector__items {
                display: block;
                top: 100%;
            }
        }

        .btn.btn-primary {
            @include paddings(16,32,16,32);
            width: 86px;
            height: 48px;
        }
    }

    @include media-breakpoint-down(xl) {
        .app-pageselector {
            border-radius: 30px;
            @include paddings(24,43,24,43);
            min-width: 314px;
            height: 170px;
            width: auto;

            &__inner {
                height: 123px;
                flex-direction: column;
                padding: 0;
            }

            &__title {
                width: 100%;
                text-align: left;
                @include text-size(16);
                @include line-height(16);
                @include margin-direction(bottom, 17);
            }

            &__selector {
                @include margins(0,0,24,0);
                width: 100%;
                max-width: none;
                flex-grow: initial;
            }

            &__menu {

                span {
                    @include text-size(14);
                    @include line-height(16);
                }
            }

            .btn.btn-primary {
                width: 100%;
            }
        }
    }
}